module.exports = __webpack_public_path__ + "static/img/xing.8915f0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/xing.png
// module id = ykdP
// module chunks = 0